import { Component, Element, Host, Prop, h } from '@stencil/core';

export interface TableCell {
  content: string;
  colspan?: number;
  rowspan?: number;
  isHeader?: boolean;
}

export interface TableRow {
  cells: TableCell[];
}

@Component({
  tag: 'spw-table',
  styleUrl: 'spw-table.scss',
  shadow: true,
})
export class SpwTable {
  @Element() el: HTMLSpwTableElement;

  /** Propriété pour l'aria-label, à des fins d'accessibilité */
  @Prop() accAriaLabel?: string;
  /** Si le header du tableau doit être sticky ou non */
  @Prop() isSticky?: boolean = false;
  /** Si défini, apparition d'une scrollbar verticale et max-height  */
  @Prop() maxHeight?: string;
  /** Si défini, apparition d'une scrollbar horizontale et max-width  */
  @Prop() minWidth?: string = '600';

  private formatSize(value?: string): string {
    if (value === undefined || value === null) {
      return 'auto';
    }
    return `${value}px`;
  }

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-table': true,
      'spw-table--is-sticky': this.isSticky,
    };
  }

  render() {
    return (
      <Host
        style={{
          '--spw-table-max-height': this.formatSize(this.maxHeight),
          '--spw-table-min-width': this.formatSize(this.minWidth),
        }}
      >
        <div class="spw-table-container">
          <table part="table" class={this.elementClass} role="table" aria-label={this.accAriaLabel}>
            <slot />
          </table>
        </div>
      </Host>
    );
  }
}
